module.exports = global.config = {
    base_url: "https://seasonings.iradar.com.my/",
    server_url: "https://seasonings.iradarx.com/",
    websocket_url: "wss://seasonings.iradarx.com:8001/",
};